<template>
  <div class="loader-wrapper">
    <div class="spinner-border loader text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
.loader-wrapper {
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  pointer-events: none;

  .loader {
    top: 50%;
    position: relative;
    margin-top: -40px;
    width: 80px;
    height: 80px;
    border-width: 10px;
    color: $primary !important;
  }
}
</style>